async function getAllFor(locale) {
  try {
    const response = await fetch(`/assets/langs/${locale}.json`);
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

export default { getAllFor };
